import { NeedsToBeMovedToStagingVehicleDetailDto } from 'dtos/toDoLists/outboundTrips'
import * as yup from 'yup'

export const NeedsToBeMovedToStagingVehicleDetailValidator = yup.object<NeedsToBeMovedToStagingVehicleDetailDto>({
  warrantyCertificateInGloveBoxFile: yup.mixed().required('Warranty Certificate In Glove Box Photo is required.'),
  parkingSpace: yup.string().max(20, 'Parking Space cannot be more than 20 characters.').required('Parking Space is required.')
})
